import { render, staticRenderFns } from "./CommodityTable.vue?vue&type=template&id=7c34fb8e&scoped=true&"
import script from "./CommodityTable.vue?vue&type=script&lang=js&"
export * from "./CommodityTable.vue?vue&type=script&lang=js&"
import style0 from "./CommodityTable.vue?vue&type=style&index=0&id=7c34fb8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c34fb8e",
  null
  
)

export default component.exports